module.exports = {
    notAllowed: {
        errorTitle: 'contractsView-depositWNMErrorTitle',
        errorBody: 'contractsView-depositWNMErrorMessage',
        backButtonLabel: 'contractSummary-backToDeposits',
        backButtonLink: '/myprofile/deposits'
    }
}